import React from 'react'
import CategoryPageHeader from '../CategoryPageHeader/CategoryPageHeader'
import SubCategoryItems from '../SubCategoryItems/SubCategoryItems'


const SubCategory = () => {
  return (
    <>
     <CategoryPageHeader/>
     <SubCategoryItems/>
    </>
  )
}

export default SubCategory
